import { get } from '../index';

export const getCompanyUsersAndBrands = idCompany => {
  return get(`/brands-company/${idCompany}`);
};
